import React, { } from "react";
import { Card, Stack } from "@mui/material";
import SvgDiagram from "../../SvgDiagram";

export default function TanitaMC780MuscleBalanceCard({ data }) {
    const image = {
        // 581 × 516
        w: 581, h: 550,
        src: "/assets/tanita/mc780/muscle_mass_balance.png"
    }
    let armBalance = data.balancearm || 0;
    let legBalance = data.balanceleg || 0;
    let rotateArm = armBalance * 2
    let rotateLeg = legBalance * 2

    let valueToPixelRatio = 10;


    // let 
    let topX = armBalance * valueToPixelRatio; // lerp(115, 596, ageRatio); // age 
    let bottomX = legBalance * valueToPixelRatio;
    
    const markers = [
        {
            type: "dot", x: topX, y: 150 - rotateArm, r: 10, color: "transparent",
            stroke: "black", strokeWidth: 4,
            origin: "center"
        },
        {
            type: "dot", x: bottomX, y: -220 + rotateLeg, r: 10, color: "transparent",
            stroke: "black", strokeWidth: 4,
            origin: "center"
        },
        {
            type: "line",  x: -65, y: 135, w: 150, color: "black",
            stroke: "black", strokeWidth: 4,
            origin: "center",
            rotate: rotateArm,
        },
        {
            type: "line", x: -65, y: -235, w: 150, color: "black",
            stroke: "black", strokeWidth: 4,
            origin: "center",
            rotate: rotateLeg,
        },
    ];

    // const imageW = 711;
    // const imageH = 531;
    return <Card sx={{ maxWidth: 900 }}>
        <Stack direction="column">
            <SvgDiagram image={image} markers={markers} />
        </Stack>
    </Card>
}